import { useEffect, useRef, useState } from "react";

export default function CalendlyEmbed({ params }) {
  const ref = useRef(null);
  const [hinweis, setHinweis] = useState("");

  useEffect(() => {
    const base = process.env.REACT_APP_CALENDLY_URL;
    let cancelled = false;

    if (!base) {
      setHinweis("Der Termin-Kalender wird eingebunden, sobald der Calendly-Link hinterlegt ist.");
      return;
    }

    function init() {
      if (cancelled || !ref.current || !window.Calendly) return;
      const p = params || {};
      const q = {
        name: p.name,
        email: p.email,
        a1: p.a1,
        a2: p.a2,
        a3: p.a3,
        a4: p.a4,
        a5: p.a5,
        a6: p.a6,
        utm_source: p.utm_source,
        utm_medium: p.utm_medium,
        utm_campaign: p.utm_campaign,
        utm_content: p.utm_content,
        utm_term: p.utm_term
      };
      const query = Object.entries(q)
        .filter(([, v]) => v)
        .map(([k, v]) => k + "=" + encodeURIComponent(v))
        .join("&");
      window.Calendly.initInlineWidget({
        url: query ? base + "?" + query : base,
        parentElement: ref.current,
        resize: true
      });
    }

    if (window.Calendly) {
      init();
      return () => {
        cancelled = true;
      };
    }

    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    script.dataset.calendly = "1";
    script.onload = init;
    script.onerror = () => {
      if (!cancelled) setHinweis("Der Kalender konnte nicht geladen werden. Bitte prüfen Sie die Calendly-URL.");
    };
    document.body.appendChild(script);

    return () => {
      cancelled = true;
    };
  }, []);

  if (hinweis) {
    return (
      <div className="rounded-xl bg-hellblau/60 p-5 text-sm text-textdunkel" data-testid="calendly-hinweis">
        {hinweis}
      </div>
    );
  }

  return <div ref={ref} style={{ minWidth: "320px", height: "660px" }} data-testid="calendly-inline-embed" />;
}
